module.exports = __webpack_public_path__ + "img/biaoqian_gongchaqinwu.5556f0ff.png";